<div *ngIf="form && formGroupName" [formGroup]="form" class="w-100">
  <mat-form-field class="w-100">
    <mat-label>{{ (label && label.length > 0) ? label : placeHolder }}</mat-label>
    <span *ngIf="prefix" matTextPrefix class="noselect">{{ prefix }}&nbsp;</span>
    <input *ngIf="viewPassword" matInput type="text" matInput [formControlName]="formGroupName" [placeholder]="placeHolder">
    <input *ngIf="!viewPassword" matInput [type]="nativeType" [attr.inputmode]="inputModeAttr" [formControlName]="formGroupName" [placeholder]="placeHolder" (keydown)="onKeydown($event)" (input)="onInput($event)">
    <span *ngIf="inputType === 'password'" [ngClass]="{'fa-eye': !viewPassword, 'fa-eye-slash': viewPassword}" class="password-toggle fa-solid" (click)="toggleViewPassword()"></span>
    <!-- type="button": these fields sit inside real <form>s (drop-off, contact). -->
    <button *ngIf="suffixIcon" matSuffix type="button" class="input-suffix-action" [disabled]="suffixBusy"
            [attr.aria-label]="suffixLabel" (click)="suffixClick.emit()">
      <span class="fa-solid" [ngClass]="suffixBusy ? 'fa-spinner fa-spin' : suffixIcon"></span>
    </button>
  </mat-form-field>
  <div *ngIf="inputType === 'password' && showPasswordHelp()" class="row help-text mx-0">
    <div *ngIf="!testMatches(upperRegEx)" class="col-auto bullet-col">&bull;</div>
    <div *ngIf="!testMatches(upperRegEx)" class="col px-0">Password must contain at least 1 uppercase letter.</div>
    <div *ngIf="!testMatches(upperRegEx)" class="w-100"></div>

    <div *ngIf="!testMatches(lowerRegEx)" class="col-auto bullet-col">&bull;</div>
    <div *ngIf="!testMatches(lowerRegEx)" class="col px-0">Password must contain at least 1 lowercase letter.</div>
    <div *ngIf="!testMatches(lowerRegEx)" class="w-100"></div>

    <div *ngIf="!testMatches(numberRegEx)" class="col-auto bullet-col">&bull;</div>
    <div *ngIf="!testMatches(numberRegEx)" class="col px-0">Password must contain at least 1 number.</div>
    <div *ngIf="!testMatches(numberRegEx)" class="w-100"></div>

    <div *ngIf="!testMatches(specialRegEx)" class="col-auto bullet-col">&bull;</div>
    <div *ngIf="!testMatches(specialRegEx)" class="col px-0">Password must contain at least 1 special character.</div>
    <div *ngIf="!testMatches(specialRegEx)" class="w-100"></div>
  </div>
</div>
